import { Map, OrderedMap } from 'immutable';
import sortBy from 'just-sort-by';

import { getExperimentAssignmentFromFeatureFlags } from 'shared/helpers/experiment';
import InterviewRequestPresenter from 'shared/presenters/InterviewRequestPresenter';
import {
  NurseSpecialtyDescription,
  NurseSpecialtySkillDescription,
} from 'shared/types';

export type NurseSpecialtyOption = {
  value: number;
  label: string;
};

export const getNurseSpecialtyOptions = (state: {
  nurseSpecialtyDescriptions?: OrderedMap<number, NurseSpecialtyDescription>;
  nurse_specialty_descriptions?: NurseSpecialtyDescription[];
}) => {
  const specialties =
    state.nurseSpecialtyDescriptions?.valueSeq()?.toArray() ||
    state.nurse_specialty_descriptions;

  return OrderedMap<number, NurseSpecialtyOption>(
    specialties.map((nsd) => [
      nsd.id,
      { value: nsd.id, label: nsd.description },
    ])
  );
};

export const getNurseSpecialtySkills = (state: {
  nurseSpecialtySkills?: {
    [key: string]: NurseSpecialtySkillDescription[];
  };
  nurse_specialty_skills?: {
    [key: string]: NurseSpecialtySkillDescription[];
  };
}) => {
  const specialtySkills =
    state.nurseSpecialtySkills || state.nurse_specialty_skills;

  return Map(specialtySkills).mapEntries<
    number,
    NurseSpecialtySkillDescription[]
  >(([specialtyId, skills]) => [
    parseInt(specialtyId, 10),
    sortBy(skills, 'position'),
  ]);
};

export const isFeatureEnabled = (state, featureName) =>
  !!state.featureFlags && state.featureFlags.includes(featureName);

// more info on usage and best practices here:
// https://www.notion.so/incrediblehealth/Experiments-721b6079cbf64089bf7d808407afd910?pvs=4
export const getExperimentAssignmentWithoutTracking = (
  state,
  experimentName,
  actorId = null
) =>
  state.featureFlags
    ? getExperimentAssignmentFromFeatureFlags(
        state.featureFlags,
        experimentName,
        actorId
      )
    : null;

export const getInterviewRequestsBySection = (
  state,
  section,
  blockType = undefined
) => {
  const { interview_requests: interviewRequests, interviews } = state;
  return interviewRequests.filter((ir) => {
    const irPresenter = new InterviewRequestPresenter(ir, { interviews });

    return (
      irPresenter.section() === section &&
      (blockType === undefined || irPresenter.blockType() === blockType)
    );
  });
};

export const getTechJobDescriptions = (state) => state.tech_job_descriptions;
